import React from 'react'
import { COLORS, FONTS, TYPOGRAPHY } from 'utils'
import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Grid,
  Text,
  Line,
  Span
} from 'components'
import FormatarNumeros from '../../../../utils/formatNumbers'

// import { Container } from './styles';
interface ITableContract {
  tableData: any[]
}
const TableSalaryReport: React.FC<ITableContract> = ({ tableData }) => {
  const mapSalary = ['a', 'b']
  const totalSalarioBase = tableData.reduce(
    (total, value) => total + value.salarioBase,
    0
  )
  const totalFolha = tableData.reduce(
    (total, value) => total + value.totalFolha,
    0
  )
  const totalHHT = tableData.reduce((total, value) => total + value.qtdHHT, 0)
  const totalHE = tableData.reduce((total, value) => total + value.he, 0)
  const totalEfetivo = tableData.reduce(
    (total, value) => total + value.efetivo,
    0
  )

  tableData = tableData.map((data) => {
    data.qtdHHT = formatarNumero(data.qtdHHT);
    data.qtdHE = formatarNumero(data.qtdHE);
    data.he = formatarNumero(data.he);
  });

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left">Mês/Ano</TableCellStyled>
              <TableCellStyled align="left">Contrato</TableCellStyled>
              <TableCellStyled align="left">Qtd.HHT</TableCellStyled>
              <TableCellStyled align="left">Qtd.HE</TableCellStyled>
              <TableCellStyled align="left">HE%</TableCellStyled>
              <TableCellStyled align="left">Justificativa HE%</TableCellStyled>
              <TableCellStyled align="left">Salário Base </TableCellStyled>
              <TableCellStyled align="left">Total Folha</TableCellStyled>
              <TableCellStyled align="left">Efetivo</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.map((row) => (
              <TableRowStyled key={row}>
                <TableCellStyled align="left">{row.periodo}</TableCellStyled>
                <TableCellStyled align="left">{row.contrato}</TableCellStyled>
                <TableCellStyled align="left">{formatarNumero(row.qtdHHT)}</TableCellStyled>
                <TableCellStyled align="left">{formatarNumero(row.qtdHE)}</TableCellStyled>
                <TableCellStyled align="left">{formatarNumero(row.he)}</TableCellStyled>
                <TableCellStyled align="left">
                  {row.justificativaHE}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {row.salarioBase
                    .toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL'
                    })
                    .toString()}
                </TableCellStyled>
                <TableCellStyled align="left">
                  {row.totalFolha
                    .toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL'
                    })
                    .toString()}
                </TableCellStyled>
                <TableCellStyled align="left">{row.efetivo}</TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <Line background={COLORS.blueFonts} />
      <Grid gridCols="1fr 1fr" gridGap="1rem" margin="1rem 0 0 0">
        <Text>
          <Span
            fontSize={TYPOGRAPHY.bodySize16}
            fontWeight={FONTS.bold}
            text="MÊS ANO ANTERIOR "
          />
          <Span
            color={COLORS.blueFonts}
            fontSize={TYPOGRAPHY.bodySize16}
            fontWeight={FONTS.bold}
            text="07/2018"
          />
        </Text>
        <Text>
          <Span
            fontSize={TYPOGRAPHY.bodySize16}
            fontWeight={FONTS.bold}
            text="MÊS/ANO "
          />
          <Span
            color={COLORS.blueFonts}
            fontSize={TYPOGRAPHY.bodySize16}
            fontWeight={FONTS.bold}
            text="08/2018"
          />
        </Text>
        {mapSalary &&
          mapSalary.map((index) => {
            return (
              <Grid
                key={index}
                gridCols="1fr"
                gridGap="1rem"
                margin="1rem 0 0 0"
              >
                <Text>
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    fontWeight={FONTS.bold}
                    text="Total Salário Base: "
                  />
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    text={totalSalarioBase
                      .toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                      })
                      .toString()}
                  />
                </Text>
                <Text>
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    fontWeight={FONTS.bold}
                    text="Total Folha: "
                  />
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    text={totalFolha
                      .toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                      })
                      .toString()}
                  />
                </Text>
                <Text>
                  <Span
                    fontSize={TYPOGRAPHY.bodySize16}
                    fontWeight={FONTS.bold}
                    text="Total HHT: "
                  />
                  <Span fontSize={TYPOGRAPHY.bodySize16} text={totalHHT} />
                </Text>
                <Text>
                  <Span
                    fontWeight={FONTS.bold}
                    fontSize={TYPOGRAPHY.bodySize16}
                    text="Total HE: "
                  />
                  <Span fontSize={TYPOGRAPHY.bodySize16} text={totalHE} />
                </Text>
                <Text>
                  <Span
                    fontWeight={FONTS.bold}
                    fontSize={TYPOGRAPHY.bodySize16}
                    text="Total Efetivo: "
                  />
                  <Span fontSize={TYPOGRAPHY.bodySize16} text={totalEfetivo} />
                </Text>
                <Text></Text>
                <Text>
                  <Span
                    fontWeight={FONTS.bold}
                    fontSize={TYPOGRAPHY.bodySize16}
                    text="% HHT x HE:"
                  />
                  <Span fontSize={TYPOGRAPHY.bodySize16} text=" 3,18" />
                </Text>
              </Grid>
            )
          })}
      </Grid>
    </>
  )
}

function formatarNumero(numero: number) {
  return FormatarNumeros.formatarNumero(numero);
}

export default TableSalaryReport
